// extracted by mini-css-extract-plugin
module.exports = {"button":"ButtonGift_button__2zTRY"};